import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Componente para el modal de login
 */
@Component({
  standalone: false,
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {

  /**
   * Crea una instancia para modal login component.
   * @param dialogRef 
   */
  constructor(public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  /**
   * on init
   */
  ngOnInit() {
  }

  /**
   * Cierra el modal
   */
  closeModal() {
    this.dialogRef.close();
  }
}
